<template>
  <div>
    <v-row class="mx-1">
      <v-col cols="12" xl="3" lg="3" md="6" sm="6" xs="12">
        <v-card color="#48A8F8" class="px-7 py-10 rounded-lg">
          <div class="d-flex flex-no-wrap justify-space-between">
            <div>
              <p class="text-h5 white--text font-weight-bold ma-0">2471</p>
              <p class="subtitle-2 white--text ma-0">Total Kehadiran</p>
            </div>
            <v-avatar class="ma-1" tile>
              <v-icon size="70" color="white">person</v-icon>
            </v-avatar>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" xl="3" lg="3" md="6" sm="6" xs="12">
        <v-card color="#3AD581" class="px-7 py-10 rounded-lg">
          <div class="d-flex flex-no-wrap justify-space-between">
            <div>
              <p class="text-h5 white--text font-weight-bold ma-0">1303</p>
              <p class="subtitle-2 white--text ma-0">Total Ketidakhadiran</p>
            </div>
            <v-avatar class="ma-1" tile>
              <v-icon size="70" color="white">person</v-icon>
            </v-avatar>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" xl="3" lg="3" md="6" sm="6" xs="12">
        <v-card color="#FBB005" class="px-7 py-10 rounded-lg">
          <div class="d-flex flex-no-wrap justify-space-between">
            <div>
              <p class="text-h5 white--text font-weight-bold ma-0">523</p>
              <p class="subtitle-2 white--text ma-0">Total Pegawai Cuti</p>
            </div>
            <v-avatar class="ma-1" tile>
              <v-icon size="70" color="white">person</v-icon>
            </v-avatar>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" xl="3" lg="3" md="6" sm="6" xs="12">
        <v-card color="#ED7272" class="px-7 py-10 rounded-lg">
          <div class="d-flex flex-no-wrap justify-space-between">
            <div>
              <p class="text-h5 white--text font-weight-bold ma-0">780</p>
              <p class="subtitle-2 white--text ma-0">Total Pegawai Dinas</p>
            </div>
            <v-avatar class="ma-1" tile>
              <v-icon size="70" color="white">person</v-icon>
            </v-avatar>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="mx-1">
      <v-col cols="12">
        <v-card class="px-7 py-7 rounded-lg">
          <p class="headline-color">Grafik Kehadiran Pegawai Bulan Juli 2020</p>
          <bar-chart />
        </v-card>
      </v-col>
    </v-row>
    <v-row class="mx-1">
      <v-col cols="12">
        <v-card class="px-7 py-7 rounded-lg" id="card-custom">
          <p class="headline-color">Persentase Dalam Grafik</p>
          <v-row>
            <v-col cols="12" xl="3" lg="3" md="3" sm="3" xs="12">
              <v-select
                placeholder="Satker"
                :items="units2"
                v-model="unit2"
                :loading="loadingUnit"
                outlined
                dense
                hide-details
                clearable
                item-text="singkatan"
                item-value="unit_kerja_2_id"
                @change="changeUnit(2)"
                @click:clear="changeUnit(2)"
              ></v-select>
            </v-col>
            <v-col cols="12" xl="3" lg="3" md="3" sm="3" xs="12">
              <v-select
                placeholder="Bagian"
                :items="units3"
                v-model="unit3"
                :loading="loadingUnit"
                outlined
                dense
                hide-details
                clearable
                item-text="singkatan"
                item-value="unit_kerja_3_id"
                @change="changeUnit(3)"
                @click:clear="changeUnit(3)"
              ></v-select>
            </v-col>
            <v-col cols="12" xl="3" lg="3" md="3" sm="3" xs="12">
              <v-select
                placeholder="Sub Bagian"
                :items="units4"
                v-model="unit4"
                :loading="loadingUnit"
                outlined
                dense
                hide-details
                clearable
                item-text="singkatan"
                item-value="unit_kerja_4_id"
                @change="changeUnit(4)"
                @click:clear="changeUnit(4)"
              ></v-select>
            </v-col>
            <v-col cols="12" xl="3" lg="3" md="3" sm="3" xs="12">
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :return-value.sync="date"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="date"
                    placeholder="Bulan"
                    append-icon="event"
                    outlined
                    dense
                    hide-details
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="date"
                  type="month"
                  locale="id"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="menu = false"
                    >Cancel</v-btn
                  >
                  <v-btn text color="primary" @click="$refs.menu.save(date)"
                    >OK</v-btn
                  >
                </v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-card-actions class="pa-0">
            <v-spacer />
            <v-btn color="#FBB005" class="px-10">
              <span class="subtitle-2 text-capitalize">Lihat Laporan</span>
            </v-btn>
          </v-card-actions>
          <v-row>
            <v-col cols="12" xl="6" lg="6" md="6" sm="6" xs="12">
              <p class="headline-color">
                Grafik Kehadiran Pegawai Bulan {{ date | dateMonthDisplay }}
                {{ date | dateYear }}
              </p>
              <bar-single-chart ref="barSinglePresent" />
            </v-col>
            <v-col cols="12" xl="6" lg="6" md="6" sm="6" xs="12">
              <p class="headline-color">
                Grafik Ketidakhadiran Pegawai Bulan
                {{ date | dateMonthDisplay }} {{ date | dateYear }}
              </p>
              <bar-single-chart ref="barSingleAbsent" />
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="mx-1">
      <v-col cols="12" xl="6" lg="6" md="6" sm="12" xs="12">
        <v-card class="px-7 py-7 rounded-lg">
          <p class="headline-color">Pegawai Naik Pangkat Juli 2020</p>
          <v-simple-table>
            <template v-slot:default>
              <tbody>
                <tr v-for="item in employeePromotes" :key="item.id">
                  <td>
                    <span class="headline-color">{{ item.no }}</span>
                  </td>
                  <td>
                    <span class="headline-color">{{ item.name }}</span>
                  </td>
                  <td>
                    <span class="headline-color">{{ item.date | date }}</span>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card>
      </v-col>
      <v-col cols="12" xl="6" lg="6" md="6" sm="12" xs="12">
        <v-card class="px-7 py-7 rounded-lg">
          <p class="headline-color">Pegawai Ulang Tahun Juli 2020</p>
          <v-simple-table>
            <template v-slot:default>
              <tbody>
                <tr v-for="item in employeePromotes" :key="item.id">
                  <td>
                    <span class="headline-color">{{ item.no }}</span>
                  </td>
                  <td>
                    <span class="headline-color">{{ item.name }}</span>
                  </td>
                  <td>
                    <span class="headline-color">{{ item.date | date }}</span>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import PublicService from "@/services/resources/public.service";
import BarChart from "@/components/Chart/Bar";
import BarSingleChart from "@/components/Chart/BarSingle";

export default {
  components: {
    BarChart,
    BarSingleChart
  },
  data() {
    return {
      menu: false,
      date: new Date().toISOString().substr(0, 7),
      loadingUnit: false,
      unit2: null,
      unit3: null,
      unit4: null,
      units2: [],
      units3: [],
      units4: [],
      employeePromotes: [
        {
          id: "1",
          no: "123456789101112",
          name: "Anggi Aditya",
          date: "2020-09-10"
        },
        {
          id: "2",
          no: "123456789101112",
          name: "Anggi Aditya",
          date: "2020-09-10"
        },
        {
          id: "3",
          no: "123456789101112",
          name: "Anggi Aditya",
          date: "2020-09-10"
        },
        {
          id: "4",
          no: "123456789101112",
          name: "Anggi Aditya",
          date: "2020-09-10"
        },
        {
          id: "5",
          no: "123456789101112",
          name: "Anggi Aditya",
          date: "2020-09-10"
        },
        {
          id: "6",
          no: "123456789101112",
          name: "Anggi Aditya",
          date: "2020-09-10"
        }
      ]
    };
  },
  methods: {
    changeUnit(type = 2) {
      if (type == 2) {
        this.units3 = this.units2.find(
          d => d.unit_kerja_2_id == this.unit2
        )?.unit_kerja3;
        this.unit3 = null;
        this.unit4 = null;
      } else if (type == 3) {
        this.units4 = this.units3.find(
          d => d.unit_kerja_3_id == this.unit3
        )?.unit_kerja4;
        this.unit4 = null;
      }
    },
    // Service
    async getListUnit() {
      try {
        this.loadingUnit = true;
        await PublicService.getUnitKerjaList()
          .then(response => {
            const { status, data } = response.data;
            if (status) {
              this.units2 = data;
            }
          })
          .catch(error => {
            throw new Error(error);
          })
          .finally(() => (this.loadingUnit = false));
      } catch (err) {
        console.error(err);
      }
    }
  },
  mounted() {
    this.getListUnit();
    this.$refs.barSinglePresent.init([
      {
        label: "Rekam",
        value: "100"
      },
      {
        label: "Hadir Dengan Status",
        value: "150"
      },
      {
        label: "Tidak Hadir Dengan Status",
        value: "80"
      },
      {
        label: "Alpha",
        value: "15"
      }
    ]);
    this.$refs.barSingleAbsent.init([
      {
        label: "Dinas Luar",
        value: "150"
      },
      {
        label: "Sakit",
        value: "20"
      },
      {
        label: "Cuti",
        value: "15"
      },
      {
        label: "Tugas Belajar",
        value: "125"
      }
    ]);
  }
};
</script>
